import { lazy, Suspense, useEffect } from "react";
import { getCSRFToken } from "@utils/csrf";
import { useVersionCheck } from "@hooks/useVersionCheck";
import { useClientPanel } from "@hooks/useClientPanel";
import useGoogleTagManagerScript from "@hooks/helpers/useGoogleTagManagerScript";
import BootScreen from "@routes/BootScreen";
import Routes from "./AppRoutes";
const ClientRoutes = lazy(() => import("./ClientRoutes"));

/** Panels with a signed-in user: tag manager, version check and CSRF refresh. */
const PanelApp = () => {
  useGoogleTagManagerScript();
  useVersionCheck();
  useEffect(() => {
    getCSRFToken();
    const interval = setInterval(() => getCSRFToken(), 300000);
    return () => clearInterval(interval);
  }, []);

  const { isClientPanel } = useClientPanel();

  if (!isClientPanel) return <Routes />;

  return (
    <Suspense fallback={<BootScreen />}>
      <ClientRoutes />
    </Suspense>
  );
};

export default PanelApp;
